var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.92871 7.14258H13.8698V9.67471H13.9412C14.6287 8.44079 16.3108 7.14258 18.8197 7.14258C24.0358 7.14258 25 10.389 25 14.6122V23.2139H19.8483V15.589C19.8483 13.7711 19.8108 11.4301 17.1697 11.4301C14.4876 11.4301 14.0769 13.4104 14.0769 15.4568V23.2139H8.92871V7.14258Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.14258H5.35711V23.2139H0V7.14258Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.35711 2.67856C5.35711 4.15712 4.15712 5.35711 2.67856 5.35711C1.19999 5.35711 0 4.15712 0 2.67856C0 1.19999 1.19999 0 2.67856 0C4.15712 0 5.35711 1.19999 5.35711 2.67856Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.9c045169f25b0e5c5fce8e2c7cbfcf05.svg";
export { ForwardRef as ReactComponent };